/*
  https://stackoverflow.com/a/52171480/1315176

  Many of the answers here are the same String.hashCode hash function taken from Java. It dates
  back to 1981 from Gosling Emacs, is extremely weak, and makes zero sense performance-wise in
  modern JavaScript. In fact, implementations could be significantly faster by using ES6 Math.imul,
  but no one took notice. We can do much better than this, at essentially identical performance.

  Here's one I did—cyrb53, a simple but high quality 53-bit hash. It's quite fast, provides very
  good* hash distribution, and because it outputs 53 bits, has significantly lower collision rates
  compared to any 32-bit hash. Also, you can ignore SA's CC license as it's public domain on my GitHub.

  *It is roughly similar to the well-known MurmurHash/xxHash algorithms. It uses a combination of
  multiplication and Xorshift to generate the hash, but not as thorough. As a result it's significantly
  simpler to implement, but may not pass all tests in SMHasher. This is not a cryptographic hash function,
  so don't use this for security purposes.

  Like any proper hash, it has a fairly acceptable "avalanche" effect, which basically means small changes
  in the input have big changes in the output, making the resulting hash appear more 'random'.
*/
var getHash = function (str, seed) {
    if (seed === void 0) { seed = 0; }
    var h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
    for (var i = 0, ch = void 0; i < str.length; i++) {
        ch = str.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507);
    h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3266489909);
    h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507);
    h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3266489909);
    return 4294967296 * (2097151 & h2) + (h1 >>> 0);
};

export { getHash };
//# sourceMappingURL=simpleInsecureHash.js.map
